import * as React from "react";
import { navigate } from "@reach/router";
import { Block } from "baseui/block";

import { BackButton } from "kw/util/Question/inputs/BackButton";

import { Referral } from "kw/components/QuestionFlow/Referral";

export function UpdatePolicyReferralPage() {
  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <>
      <Block paddingLeft="scale800" paddingTop="scale100" minHeight="36px">
        <BackButton onClick={handleBackClick} />
      </Block>
      <Referral />
    </>
  );
}
